import { useTheme } from '@mui/material'
import { Children, Fragment, memo } from 'react'

type ChildSpacerProps = {
  size?: number
  direction?: 'vertical' | 'horizontal'
}

/**
 * @deprecated Use `Stack` instead.
 */
const ChildSpacer: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<ChildSpacerProps>>
> = (props) => {
  const theme = useTheme()
  const children = Children.toArray(props.children)
  const size = theme.spacing(props.size || 1)
  let spacerChild: React.ReactNode = undefined

  if (props.direction === 'vertical') {
    spacerChild = <div style={{ height: size }} />
  } else {
    spacerChild = <span style={{ width: size, display: 'inline-block' }} />
  }

  return (
    <Fragment>
      {children.map((child, i) => {
        /* eslint-disable react/no-array-index-key */
        return (
          <Fragment key={`child-spacer-${i}`}>
            {child}
            {i < children.length - 1 ? spacerChild : undefined}
          </Fragment>
        )
        /* eslint-enable react/no-array-index-key */
      })}
    </Fragment>
  )
}

export default memo(ChildSpacer)
